export default __webpack_public_path__ + "static/media/966.35230c9b.gif";